import * as yup from "yup";

export default yup.object().shape({
  HiringTitle: yup.string().required("제목을 입력하세요."),
  HiringDeadline: yup.string().required("마감일을 선택해 주세요."),
  HiringContent: yup.string().required("내용을 입력해 주세요."),
});
